import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    const check = () => {
      const el = document.getElementById("first-cta");
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-128" data-mp="38ayz6oxtmpld">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 bg-navy-950/90 p-3 backdrop-blur md:inset-x-auto md:bottom-6 md:right-6 md:bg-transparent md:p-0 md:backdrop-blur-none" data-id="element-129" data-mp="38bqr9ps7m56w">
          <motion.a href={CHECKOUT_URL} animate={reduce ? undefined : {
        x: [0, -7, 7, -6, 6, -3, 3, 0]
      }} transition={{
        duration: 0.45,
        repeat: Infinity,
        repeatDelay: 1.3,
        ease: "easeInOut"
      }} className="flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-6 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-[0_5px_0_0_#0f6b31,0_14px_30px_-8px_rgba(0,0,0,0.5)] hover:bg-cta-hover focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-300 md:w-auto md:text-lg" data-id="element-130" data-mp="2pb343mh3lhtf">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden data-id="element-131" data-mp="4m6u24vsmbg8" />
            <span className="whitespace-nowrap" data-id="element-132" data-mp="4k2q5mxw9cfy">Get it now — $27</span>
          </motion.a>
        </motion.div>}
    </AnimatePresence>;
}